export const ERROR_CLASSNAME = 'field-error';
export const DEBOUNCE_WAIT = 400;
export const EMPTY_PLACEHOLDER = '-';
